import { Type, type Static } from "@sinclair/typebox";
import { AgentInvocationAuthorizationRequestSchema } from "./agent-host.ts";
import { UuidSchema } from "./identifiers.ts";
import {
  UserAutomationCreateSchema,
  UserAutomationUpdateSchema,
  UserAutomationListSchema
} from "./user-automation.ts";

export const UserAutomationManagementRequestSchema = Type.Object(
  {
    invocation: AgentInvocationAuthorizationRequestSchema,
    command: Type.Union([
      Type.Object(
        { operation: Type.Literal("create"), input: UserAutomationCreateSchema },
        { additionalProperties: false }
      ),
      Type.Object(
        { operation: Type.Literal("list"), input: UserAutomationListSchema },
        { additionalProperties: false }
      ),
      Type.Object(
        {
          operation: Type.Literal("update"),
          automationId: UuidSchema,
          input: UserAutomationUpdateSchema
        },
        { additionalProperties: false }
      ),
      Type.Object(
        {
          operation: Type.Literal("cancel"),
          automationId: UuidSchema,
          revision: Type.Integer({ minimum: 1 })
        },
        { additionalProperties: false }
      )
    ])
  },
  { additionalProperties: false }
);
export type UserAutomationManagementRequest = Static<typeof UserAutomationManagementRequestSchema>;
